import apiFetch from '@wordpress/api-fetch';
import { Customer } from '../models/customer';

export async function getCustomers(): Promise<Customer[]> {
	const response: Customer[] = await apiFetch({
		path: '/bookr/v1/customers',
		method: 'GET',
	});

	return response;
}

export async function deleteCustomer(id: number): Promise<any> {
	return await apiFetch({
		path: `/bookr/v1/customer?id=${id}`,
		method: 'DELETE',
	});
}
